import React from 'react'
import PropTypes from 'prop-types'
import Pill from "../../../../../gd-components/molecules/pill/pill"

const debug = false
// const debug = "FieldSelectFields_Pill"

export default function FieldSelectFields_Pill(props:any) {

    if (!props.field) return null

    debug && console.log(debug, 'render', props.field)

    const onClick = () => {
        if(props.onClick) props.onClick(props.field.fieldId)
    }

    const onDelete = () => {
        if(props.onDelete) props.onDelete(props.field.fieldId)
    }

    return <Pill className  = {props.className}
                 size       = {props.size}
                 label      = {props.field.label}
                 icon       = {props.field.icon}
                 palette    = "gray"
                 onDelete   = {onDelete}
                 onClick    = {onClick}/>

}

FieldSelectFields_Pill.propTypes = {
    size        : PropTypes.oneOf(['26', '22']),
    field       : PropTypes.object,
    className   : PropTypes.string,
    style       : PropTypes.any,

    onClick     : PropTypes.func,
    onDelete    : PropTypes.func
}

FieldSelectFields_Pill.defaultProps = {
    size        : '26'
}
